module.exports = __webpack_public_path__ + "static/img/green_animate2.b3ca9ab8.png";